var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "none",
    clipRule: "evenodd",
    d: "M 23 5.5 C 23 7.985 20.985 10 18.5 10 C 17.099 10 15.848 9.36 15.023 8.357 L 9.765 10.609 C 9.848 10.95 10 11.63 10 11.997 C 10 12.366 9.741 13.693 9.657 14.036 C 9.657 14.036 14.542 16.124 14.378 16.288 C 15.203 15.285 17.099 14 18.5 14 C 20.985 14 23 16.015 23 18.5 C 23 20.985 20.985 23 18.5 23 C 16.015 23 13.946 20.77 13.946 18.285 C 13.946 17.917 14.098 17.451 14.182 17.109 L 9.46 14.426 C 8.634 15.428 6.9 16.497 5.5 16.497 C 3.015 16.497 1 14.482 1 11.997 C 1 9.512 3.015 7.497 5.5 7.497 C 6.902 7.497 8.907 8.891 9.732 9.896 L 14.451 7.804 C 14.367 7.462 14 5.868 14 5.5 C 14 3.015 16.015 1 18.5 1 C 20.985 1 23 3.015 23 5.5 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.c300eecf94f67d5c12b9d5c6c2be047c.svg";
export { ForwardRef as ReactComponent };